import { styled } from '@/stitches.config';
import { Box } from '@base-app';

export const StyledEditCard = styled(Box, {
  border: '$borderWidths$1 solid $seafoam400',
  borderRadius: '$radii$6',
});

export const StyledTitleContent = styled(Box, {
  background: '$seafoam800',
  borderBottom: '$borderWidths$1 solid $seafoam400',
  display: 'flex',
  justifyContent: 'space-between',
  padding: '$3 $8',
});

export const StyledContent = styled(Box, {
  display: 'flex',
  flexWrap: 'wrap',
  padding: '$8',
});

export const StyledTitle = styled(Box, {
  color: '$darkBlue400',
  fontSize: '$md',
  fontWeight: '$bold',
});
